module.exports = __webpack_public_path__ + "static/media/cultivate-fertilize.663470d7.svg";